<script lang="ts" setup>
import type { BreadcrumbsItem } from '~/types/breadcrumbs'

defineProps<{
  items: BreadcrumbsItem[]
}>()
</script>

<template>
  <div class="hidden lg:flex lg:items-center">
    <template v-for="(x, index) in items" :key="index">
      <NuxtLink
        class="
          text-sm leading-[1.71] text-main-dark !no-underline opacity-[.4] transition-opacity duration-200
          hover:opacity-100
        "
        :to="x.path"
      >
        {{ x.name }}
      </NuxtLink>

      <span v-if="index !== items.length - 1" class="mx-[3px] text-main-dark opacity-[.4]">
        —
      </span>
    </template>
  </div>
</template>
